import { ResponseError } from 'shared/common/errors/responseError';
import { preparePolygons } from 'shared/common/mappers/preparePolygons';
import { IApplicationContext } from 'shared/common/types/applicationContext';
import { IPricesAndPolygonsData } from 'shared/common/types/prices';
import { TPricesAndPolygonsResponse } from './types';

export async function fetchPricesAndPolygons({
  httpApi,
  custom,
}: IApplicationContext): Promise<IPricesAndPolygonsData> {
  const { response, statusCode } = (await httpApi.fetch({
    apiType: 'external',
    microserviceName: 'info-api',
    assertStatusCodes: [200, 400],
    pathApi: '/api/monetization/get-info-' + custom.iteration,
    method: 'GET',
  })) as TPricesAndPolygonsResponse;

  if (statusCode !== 200) {
    throw new ResponseError({
      domain: 'info-monetization-frontend',
      message: String(response.message),
    });
  }

  return { prices: response.prices, polygons: preparePolygons({ ...response }) };
}
